import { render, staticRenderFns } from "./DxProductPerformance.vue?vue&type=template&id=772e2496&"
import script from "./DxProductPerformance.vue?vue&type=script&lang=js&"
export * from "./DxProductPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports